import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';

const Row = ({ data, colSize, textAlign }) => {
  const { Table: { Row, Cell } } = UX2.Element;
  return (
    <Row data-id='row-container' section='default'>
      {data.map((row, index) => (
        <Cell
          data-id='col-container'
          children={ row.content }
          style={{ textAlign: textAlign[index], flex: (colSize[index] || 1), textTransform: (row.uppercase ? 'uppercase' : 'none') }}
          key={ `table-col-${index}` }
        />
      ))}
    </Row>
  );
};

Row.propTypes = {
  data: PropTypes.array.isRequired,
  colSize: PropTypes.array,
  textAlign: PropTypes.array
};

Row.defaultProps = {
  data: [],
  colSize: [],
  textAlign: []
};

export default Row;
